export const PERMISSION = {
  Config: {
    All: {
      All: "Config_All_All",
    },
    Location: {
      All: "Config_Location_All",
      View: "Config_Location_View",
      Update: "Config_Location_Update",
    },
    Weeks: {
      All: "Config_Weeks_All",
      View: "Config_Weeks_View",
    },
    "Contract Types": {
      All: "Config_Contract Types_All",
      View: "Config_Contract Types_View",
      Update: "Config_Contract Types_Update",
    },
    Holidays: {
      All: "Config_Holidays_All",
      View: "Config_Holidays_View",
      Update: "Config_Holidays_Update",
    },
    Sports: {
      All: "Config_Sports_All",
      View: "Config_Sports_View",
      Update: "Config_Sports_Update",
    },
    "Cost Centres": {
      All: "Config_Cost Centres_All",
      View: "Config_Cost Centres_View",
    },
    Leaves: {
      All: "Config_Leaves_All",
      View: "Config_Leaves_View",
      Update: "Config_Leaves_Update",
    },
  },
  Access: {
    All: {
      All: "Access_All_All",
    },
    "Manage Roles": {
      All: "Access_Manage Roles_All",
      View: "Access_Manage Roles_View",
      Update: "Access_Manage Roles_Update",
    },
    "Manage Role Permission": {
      All: "Access_Manage Role Permission_All",
      View: "Access_Manage Role Permission_View",
      Update: "Access_Manage Role Permission_Update",
    },
    "Manage User Roles": {
      View: "Access_Manage User Roles_View",
      Update: "Access_Manage User Roles_Update",
    },
  },
  "My Store": {
    All: {
      All: "My Store_All_All",
    },
    "Manage Store Employees": {
      All: "My Store_Manage Store Employees_All",
      View: "My Store_Manage Store Employees_View",
      Update: "My Store_Manage Store Employees_Update",
    },
    "Manage Clusters": {
      All: "My Store_Manage Clusters_All",
      View: "My Store_Manage Clusters_View",
      "Update Cluster": "My Store_Manage Clusters_Update Cluster",
      "Update Employees": "My Store_Manage Clusters_Update Employees",
    },
    "Manage Secondary Jobs": {
      All: "My Store_Manage Secondary Jobs_All",
      View: "My Store_Manage Secondary Jobs_View",
      "Update Secondary Jobs":
        "My Store_Manage Secondary Jobs_Update Secondary Jobs",
      "Update Employees": "My Store_Manage Secondary Jobs_Update Employees",
    },
    "Manage Shifts": {
      All: "My Store_Manage Shifts_All",
      View: "My Store_Manage Shifts_View",
      Update: "My Store_Manage Shifts_Update",
    },
    "Day View": {
      All: "My Store_Day View_All",
      View: "My Store_Day View_View",
    },
    "Cluster Job Configuration": {
      All: "My Store_Cluster Job Configuration_All",
      View: "My Store_Cluster Job Configuration_View",
      Update: "My Store_Cluster Job Configuration_Update",
    },
    "Cluster Job Planning": {
      All: "My Store_Cluster Job Planning_All",
      View: "My Store_Cluster Job Planning_View",
      Update: "My Store_Cluster Job Planning_Update",
    },
    "Store Configuration": {
      All: "My Store_Store Configuration_All",
      View: "My Store_Store Configuration_View",
      Update: "My Store_Store Configuration_Update",
    },
    "Affinity Rate": {
      All: "My Store_Affinity Rate_All",
      View: "My Store_Affinity Rate_View",
    },
  },
  Leave: {
    All: {
      All: "Leave_All_All",
    },
    "My Leaves & Week Off's": {
      All: "Leave_My Leaves & Week Off's_All",
      View: "Leave_My Leaves & Week Off's_View",
      Apply: "Leave_My Leaves & Week Off's_Apply",
    },
    "My Team Leaves": {
      All: "Leave_My Team Leaves_All",
      View: "Leave_My Team Leaves_View",
    },
  },
  "Layout Roster": {
    All: {
      All: "Layout Roster_All_All",
    },
    "Manage Roster": {
      All: "Layout Roster_Manage Roster_All",
      View: "Layout Roster_Manage Roster_View",
      Update: "Layout Roster_Manage Roster_Update",
    },
    "My Team Roster": {
      All: "Layout Roster_My Team Roster_All",
      View: "Layout Roster_My Team Roster_View",
    },
  },
  "Secondary Roster": {
    All: {
      All: "Secondary Roster_All_All",
    },
    "Manage Roster": {
      All: "Secondary Roster_Manage Roster_All",
      View: "Secondary Roster_Manage Roster_View",
      Update: "Secondary Roster_Manage Roster_Update",
    },
    "My Team Roster": {
      All: "Secondary Roster_My Team Roster_All",
      View: "Secondary Roster_My Team Roster_View",
    },
  },
  Migration: {
    All: {
      All: "Migration_All_All",
    },
    "Manage Migration": {
      All: "Migration_Manage Migration_All",
      "Perform Refresh": "Migration_Manage Migration_Perform Refresh",
    },
    "V1 To Slave": {
      All: "Migration_V1 To Slave_All",
      View: "Migration_V1 To Slave_View",
      "Perform Refresh": "Migration_V1 To Slave_Perform Refresh",
    },
    "Effi To Humine": {
      All: "Migration_Effi To Humine_All",
      View: "Migration_Effi To Humine_View",
      "Perform Refresh": "Migration_Effi To Humine_Perform Refresh",
    },
  },
  "Shift Swap": {
    "My Shift Swaps": {
      All: "Shift Swap_My Shift Swaps_All",
      Apply: "Shift Swap_My Shift Swaps_Apply",
      View: "Shift Swap_My Shift Swaps_View",
    },
  },
  "Payroll & Manual Hours": {
    "Manual Hours": {
      View: "Payroll & Manual Hours_Manual Hours_View",
      All: "Payroll & Manual Hours_Manual Hours_All",
      Add: "Payroll & Manual Hours_Manual Hours_Add",
    },
    "Hours Approval": {
      All: "Payroll & Manual Hours_Hours Approval_All",
      View: "Payroll & Manual Hours_Hours Approval_View",
      Approve: "Payroll & Manual Hours_Hours Approval_Approve",
    },
    "Extract Payroll": {
      All: "Payroll & Manual Hours_Extract Payroll_All",
      Extract: "Payroll & Manual Hours_Extract Payroll_Extract",
    },
  },
  "Working Hours": {
    "My Team Work Hours": {
      View: "Working Hours_My Team Work Hours_View",
      All: "Working Hours_My Team Work Hours_All",
    },
    All: {
      All: "Working Hours_All_All",
    },
    "My Work Hours": {
      View: "Working Hours_My Work Hours_View",
      All: "Working Hours_My Work Hours_All",
    },
  },
  "Eco Mobility": {
    "My Eco Mobility": {
      All: "Eco Mobility_My Eco Mobility_All",
      View: "Eco Mobility_My Eco Mobility_View",
      Add: "Eco Mobility_My Eco Mobility_Add",
    },
    "My Team Eco Mobility": {
      View: "Eco Mobility_My Team Eco Mobility_View",
      Edit: "Eco Mobility_My Team Eco Mobility_Edit",
    },
  },
  Dashboards: {
    All: {
      All: "Dashboards_All_All",
    },
    "Hours Distribution": {
      All: "Dashboards_Hours Distribution_All",
      View: "Dashboards_Hours Distribution_View",
    },
    "Manual Hour Contribution": {
      All: "Dashboards_Manual Hour Contribution_All",
      View: "Dashboards_Manual Hour Contribution_View",
    },
    Efficiency: {
      All: "Dashboards_Efficiency_All",
      View: "Dashboards_Efficiency_View",
    },
    "Hours Visibility": {
      All: "Dashboards_Hours Visibility_All",
      View: "Dashboards_Hours Visibility_View",
    },
    "Eco Mobility": {
      All: "Dashboards_Eco Mobility_All",
      View: "Dashboards_Eco Mobility_View",
      Export: "Dashboards_Eco Mobility_Export",
    },
    "Affinity Rate": {
      All: "Dashboards_Affinity Rate_All",
      View: "Dashboards_Affinity Rate_View",
    },
  },
  Integration: {
    "Integrated Job Sync": {
      All: "Integration_Integrated Job Sync_All",
      View: "Integration_Integrated Job Sync_View",
      "Perform Sync": "Integration_Integrated Job Sync_Perform Sync",
    },
  },
};
